import { isProduction, isStaging, isLocal } from './urlCheck';
/**
 * Returns endpoint base URL via
 * current environment's hostname
 *
 * @param  {String} hostname
 * @return {String}
 *
 */
function redirectFromHostname(hostname) {
  switch (true) {
    case isProduction(hostname):
      return 'https://api.shopkeepapp.com';

    case isStaging(hostname):
      return 'https://api.shopkeepapp.com';

    case isLocal(hostname):
      return 'http://api.vcap.me:3000';

    default:
      throw new Error('Please run on an acceptable environment.');
  }
}

export default redirectFromHostname;
